module.exports = __webpack_public_path__ + "img/journal_file_copy.89c63ce3.svg";